
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, list_type, float64_type, class_type, bool_type, option_type, anonRecord_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName, Receiver_$reflection } from "../../Shared/User.js";
import { Storage_$reflection } from "../../Shared/Storage.js";
import { ConsumableReservationFormDto, ConsumableDetailReservationDto_$reflection, ConsumableDetailDto_$reflection, ConsumableReservationResponse_$reflection, ConsumableReservationFormDto_$reflection } from "../../Shared/Consumable.js";
import { ConsumableId__get_unwrap, FormState_get_empty, RequestedValue$1, FormState__startLoading, ConsumableReservationId, ConsumableId as ConsumableId_1, TokenDataDto_$reflection, FormState_$reflection, RequestedValue$1_$reflection, PostResponse$1_$reflection } from "../../Shared/Shared.js";
import { getConsumableDetailDto, updateConsumableReservation, createConsumableReservation, checkReservationCmd } from "../../Requests/Consumable.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { empty as empty_1, sortBy, toArray, contains, filter, map as map_1, find, ofArray, tryFind, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { defaultArg, value as value_10, unwrap, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { safeHash, comparePrimitives, equals, createObj, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton as singleton_1, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { utcNow, toString, compare } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { InformationAlert, WarningAlert } from "../../Components/Alert.js";
import { Select, GroupedSelect } from "../../Components/Select.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { NumberInput, AutoSuggestInput } from "../../Components/Input.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextArea } from "../../Components/TextArea.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { TextButton } from "../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSelectedReceiver", "SetSelectedStorage", "SetName", "SetIsReceiverNotificationSet", "SetDescription", "SetStartDate", "SetEndDate", "SetQuantity", "CreateConsumableReservation", "UpdateConsumableReservation", "ConsumableReservationSaved", "ReservationNameSuggestionsFetched", "ReceiversFetched", "StoragesFetched", "ConsumableFetched", "InitSelectedStorage", "InitSelectedReceiver", "FetchReservationCheck", "ReservationCheckFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Consumables.Dialogs.EditReservationFormDialog.Msg", [], Msg, () => [[["Item", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", class_type("System.DateTime")]], [["Item", class_type("System.DateTime")]], [["Item", option_type(float64_type)]], [["Item", ConsumableReservationFormDto_$reflection()]], [["Item", ConsumableReservationFormDto_$reflection()]], [["Item", PostResponse$1_$reflection(ConsumableReservationResponse_$reflection())]], [["Item", list_type(string_type)]], [["Item", list_type(Receiver_$reflection())]], [["Item", list_type(Storage_$reflection())]], [["Item", ConsumableDetailDto_$reflection()]], [], [], [], [["Item", bool_type]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(Consumable, FormState, SuccessCallback, StartDate, EndDate, Description, Name, SelectedUser, IsUserNotificationSet, OnClose, ConsumableReservation, ReservationNameSuggestions, Receivers, Storages, SelectedStorage, Quantity, UserData, ReservationId, IsEnoughStock) {
        super();
        this.Consumable = Consumable;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Description = Description;
        this.Name = Name;
        this.SelectedUser = SelectedUser;
        this.IsUserNotificationSet = IsUserNotificationSet;
        this.OnClose = OnClose;
        this.ConsumableReservation = ConsumableReservation;
        this.ReservationNameSuggestions = ReservationNameSuggestions;
        this.Receivers = Receivers;
        this.Storages = Storages;
        this.SelectedStorage = SelectedStorage;
        this.Quantity = Quantity;
        this.UserData = UserData;
        this.ReservationId = ReservationId;
        this.IsEnoughStock = IsEnoughStock;
    }
}

function State_$reflection() {
    return record_type("Consumables.Dialogs.EditReservationFormDialog.State", [], State, () => [["Consumable", RequestedValue$1_$reflection(ConsumableDetailDto_$reflection())], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["Description", string_type], ["Name", string_type], ["SelectedUser", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))], ["IsUserNotificationSet", bool_type], ["OnClose", lambda_type(unit_type, unit_type)], ["ConsumableReservation", option_type(ConsumableDetailReservationDto_$reflection())], ["ReservationNameSuggestions", list_type(string_type)], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["SelectedStorage", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))], ["Quantity", option_type(float64_type)], ["UserData", TokenDataDto_$reflection()], ["ReservationId", string_type], ["IsEnoughStock", bool_type]]);
}

function update(msg, state) {
    switch (msg.tag) {
        case 17: {
            const matchValue = state.SelectedStorage;
            const matchValue_1 = state.Quantity;
            const matchValue_2 = state.Consumable;
            let matchResult, consumable, quantity, selectedStorage;
            if (matchValue == null) {
                matchResult = 1;
            }
            else if (matchValue_1 == null) {
                matchResult = 1;
            }
            else if (matchValue_2.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                consumable = matchValue_2.fields[0];
                quantity = matchValue_1;
                selectedStorage = matchValue;
            }
            switch (matchResult) {
                case 0:
                    return [state, checkReservationCmd(new ConsumableId_1(parse(consumable.Id)), state.StartDate, state.EndDate, selectedStorage.value.Id, quantity, new ConsumableReservationId(parse(state.ReservationId)), (Item_2) => (new Msg(18, [Item_2])), (Item_3) => (new Msg(19, [Item_3])))];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 0:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, msg.fields[0], state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_none()];
        case 1:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, msg.fields[0], state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), singleton((dispatch) => {
                dispatch(new Msg(17, []));
            })];
        case 3:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, msg.fields[0], state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_none()];
        case 2:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, msg.fields[0], state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_none()];
        case 4:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, msg.fields[0], state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_none()];
        case 5:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, msg.fields[0], state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), singleton((dispatch_1) => {
                dispatch_1(new Msg(17, []));
            })];
        case 6:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, msg.fields[0], state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), singleton((dispatch_2) => {
                dispatch_2(new Msg(17, []));
            })];
        case 7:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, msg.fields[0], state.UserData, state.ReservationId, state.IsEnoughStock), singleton((dispatch_3) => {
                dispatch_3(new Msg(17, []));
            })];
        case 8:
            return [new State(state.Consumable, FormState__startLoading(state.FormState), state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), createConsumableReservation(msg.fields[0], (Item_4) => (new Msg(10, [Item_4])), (Item_5) => (new Msg(19, [Item_5])))];
        case 9:
            return [new State(state.Consumable, FormState__startLoading(state.FormState), state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), updateConsumableReservation(msg.fields[0], (Item_6) => (new Msg(10, [Item_6])), (Item_7) => (new Msg(19, [Item_7])))];
        case 12:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, new RequestedValue$1(1, [msg.fields[0]]), state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), singleton((dispatch_4) => {
                dispatch_4(new Msg(16, []));
            })];
        case 16: {
            const matchValue_4 = state.Receivers;
            const matchValue_5 = state.ConsumableReservation;
            let matchResult_1, receivers_1, reservation;
            if (matchValue_4.tag === 0) {
                matchResult_1 = 1;
            }
            else if (matchValue_5 == null) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 0;
                receivers_1 = matchValue_4.fields[0];
                reservation = matchValue_5;
            }
            switch (matchResult_1) {
                case 0:
                    return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, map((receiver_2) => ({
                        label: receiver_2.Name,
                        value: receiver_2,
                    }), tryFind((receiver_1) => (receiver_1.Id === reservation.ReceiverInformation.ReceiverId), receivers_1)), state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_none()];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 10: {
            const matchValue_7 = msg.fields[0].Result;
            switch (matchValue_7.tag) {
                case 1: {
                    state.SuccessCallback();
                    return [new State(state.Consumable, FormState_get_empty(), state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_none()];
                }
                case 2:
                    return [new State(state.Consumable, FormState_get_empty(), state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_errorToast("dialog.reservation.toast_messages.not_enough_stock")];
                default: {
                    state.SuccessCallback();
                    return [new State(state.Consumable, FormState_get_empty(), state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                        state.SuccessCallback();
                    }), Cmd_ofEffect((_arg_1) => {
                        state.OnClose();
                    }), Cmd_successToast("dialog.reservation.toast_messages.created")]))];
                }
            }
        }
        case 11:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, msg.fields[0], state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_none()];
        case 13:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, new RequestedValue$1(1, [msg.fields[0]]), state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), singleton((dispatch_5) => {
                dispatch_5(new Msg(15, []));
            })];
        case 15: {
            const matchValue_8 = state.Storages;
            const matchValue_9 = state.ConsumableReservation;
            let matchResult_2, reservation_1, storages;
            if (matchValue_8.tag === 0) {
                matchResult_2 = 1;
            }
            else if (matchValue_9 == null) {
                matchResult_2 = 1;
            }
            else {
                matchResult_2 = 0;
                reservation_1 = matchValue_9;
                storages = matchValue_8.fields[0];
            }
            switch (matchResult_2) {
                case 0:
                    return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, map((storage_2) => ({
                        label: storage_2.Name,
                        value: storage_2,
                    }), tryFind((storage_1) => (storage_1.Name === reservation_1.StorageName), storages)), state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_none()];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 14: {
            const response_4 = msg.fields[0];
            const reservation_3 = find((reservation_2) => (reservation_2.Id === state.ReservationId), response_4.Reservations);
            return [new State(new RequestedValue$1(1, [response_4]), state.FormState, state.SuccessCallback, reservation_3.StartDate, reservation_3.EndDate, reservation_3.Description, reservation_3.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, reservation_3, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, reservation_3.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_batch(ofArray([singleton((dispatch_6) => {
                dispatch_6(new Msg(15, []));
            }), singleton((dispatch_7) => {
                dispatch_7(new Msg(16, []));
            })]))];
        }
        case 19:
            return [new State(state.Consumable, FormState_get_empty(), state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, state.IsEnoughStock), Cmd_none()];
        default:
            return [new State(state.Consumable, state.FormState, state.SuccessCallback, state.StartDate, state.EndDate, state.Description, state.Name, state.SelectedUser, state.IsUserNotificationSet, state.OnClose, state.ConsumableReservation, state.ReservationNameSuggestions, state.Receivers, state.Storages, state.SelectedStorage, state.Quantity, state.UserData, state.ReservationId, msg.fields[0]), Cmd_none()];
    }
}

function DialogBody(props) {
    let elems_3;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const formState = props.FormState.IsLoading ? "disabled" : "enabled";
    const availableStorages = map_1((stockPerStorage) => stockPerStorage.StorageId, props.Consumable.StockPerStorage);
    const storageOptions = map_1((storage_1) => ({
        label: storage_1.Name,
        value: storage_1,
    }), filter((storage) => contains(unwrapStorageId(storage.Id), availableStorages, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), props.Storages));
    return reactElement("div", createObj(ofArray([["id", "tool-reservation-dialog"], ["className", join(" ", ["grid", "gap-5"])], (elems_3 = toList(delay(() => {
        let matchValue, reminder, elems, arg_1;
        return append((matchValue = tryFind((r_1) => {
            if (compare(r_1.Date, props.StartDate) >= 0) {
                return compare(r_1.Date, props.EndDate) <= 0;
            }
            else {
                return false;
            }
        }, filter((r) => !r.IsConfirmed, props.ReminderDates)), (matchValue == null) ? (empty()) : ((reminder = matchValue, singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["w-96"])], (elems = [createElement(WarningAlert, {
            Label: (arg_1 = {
                dateString: toString(reminder.Date, "dd.MM.yyyy"),
                reminderName: reminder.Title,
            }, patternInput[1].t("tool.reservation_dialog.overlapping_date_warning", arg_1)),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))))))), delay(() => append(!props.IsEnoughStock ? singleton_1(createElement(WarningAlert, {
            Label: t("validation.reservation.reservation_stock_warning"),
        })) : empty(), delay(() => append(singleton_1(createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
            ComponentState: formState,
            IsClearable: false,
            Key: "assign-tool-select",
            Label: t("general.user"),
            NoOptionsMessage: "select.employee_no_options",
            OnChange: props.SetSelectedReceiver,
            Options: map_1((tupledArg) => {
                const receiverType = tupledArg[0];
                const receivers_1 = toArray(sortBy((receiver_2) => receiver_2.label.toLowerCase(), map_1((receiver_1) => {
                    const matchValue_2 = receiver_1.LocationName;
                    if (matchValue_2 != null) {
                        const locationName = matchValue_2;
                        if (equals(receiverType, new ReceiverTypeName(4, []))) {
                            return {
                                label: concat(locationName, " - ", ...receiver_1.Name),
                                value: receiver_1,
                            };
                        }
                        else {
                            return {
                                label: concat(receiver_1.Name, " - ", ...locationName),
                                value: receiver_1,
                            };
                        }
                    }
                    else {
                        return {
                            label: receiver_1.Name,
                            value: receiver_1,
                        };
                    }
                }, tupledArg[1]), {
                    Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                }));
                return {
                    label: Helper_receiverTypeNameTranslation(t, receiverType),
                    options: receivers_1,
                };
            }, List_groupBy((receiver) => receiver.ReceiverType, filter((u) => {
                if (props.IsReceiverNotificationSet) {
                    const matchValue_1 = u.ReceiverType;
                    switch (matchValue_1.tag) {
                        case 10:
                            return false;
                        case 1:
                        case 5:
                        case 8:
                        case 6:
                        case 2:
                        case 7:
                        case 3:
                        case 4:
                        case 9:
                            return false;
                        default:
                            return true;
                    }
                }
                else {
                    return true;
                }
            }, props.Users), {
                Equals: equals,
                GetHashCode: (x_1) => (safeHash(x_1) | 0),
            })),
            PlaceholderKey: "select.employee_placeholder",
            Value: unwrap(props.SelectedReceiver),
        }))), delay(() => append(singleton_1(createElement(Select, {
            ComponentState: formState,
            IsClearable: false,
            Label: t("tool.choose_storage"),
            NoOptionsMessage: "select.storage_no_options",
            OnChange: props.SetSelectedStorage,
            Options: storageOptions,
            PlaceholderKey: "select.storage_placeholder",
            TestId: "",
            Value: unwrap(props.SelectedStorage),
        })), delay(() => {
            let dependencies_1;
            return append(singleton_1((dependencies_1 = [props.ReservationName, props.ReservervationNameSuggestions, formState], reactApi.useMemo(() => createElement(AutoSuggestInput, {
                ComponentState: formState,
                Label: t("general.name"),
                OnChange: props.SetReservationName,
                Suggestions: props.ReservervationNameSuggestions,
                TestId: "",
                Value: props.ReservationName,
            }), dependencies_1))), delay(() => append(singleton_1(createElement(InformationAlert, {
                Label: t("tool.reservation_dialog.reservation_name_tooltip"),
            })), delay(() => {
                let elems_1;
                return append(singleton_1(reactElement("div", createObj(singleton((elems_1 = [createElement(DatePicker, {
                    ComponentState: formState,
                    IsClearable: false,
                    Label: t("general.start_date"),
                    OnChange: (date) => {
                        if (date == null) {
                        }
                        else {
                            const date_1 = date;
                            if (compare(date_1, props.EndDate) > 0) {
                                props.SetEndDate(date_1);
                            }
                            props.SetStartDate(date_1);
                        }
                    },
                    TestId: "",
                    Value: props.StartDate,
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))), delay(() => {
                    let elems_2;
                    return append(singleton_1(reactElement("div", createObj(singleton((elems_2 = [createElement(DatePicker, {
                        ComponentState: formState,
                        IsClearable: false,
                        Label: t("general.end_date"),
                        MinDate: props.StartDate,
                        OnChange: (date_2) => {
                            if (date_2 == null) {
                            }
                            else {
                                props.SetEndDate(date_2);
                            }
                        },
                        TestId: "",
                        Value: props.EndDate,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))), delay(() => append(singleton_1(createElement(NumberInput, {
                        ComponentState: formState,
                        Label: t("general.quantity"),
                        OnChange: props.SetQuantity,
                        TestId: "tool-with-quantity-reservation-quantity-input",
                        Value: unwrap(map((value_8) => value_8, props.Quantity)),
                    })), delay(() => singleton_1(createElement(TextArea, {
                        ComponentState: formState,
                        Label: t("general.description"),
                        OnChange: props.SetDescription,
                        TestId: "reservation-description",
                        Value: props.Description,
                    }))))));
                }));
            }))));
        }))))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function init(consumableId, successCallback, selectedUser, isUserNotificationSet, onClose, userData, reservationId) {
    return [new State(new RequestedValue$1(0, []), FormState_get_empty(), successCallback, utcNow(), utcNow(), "", "", undefined, isUserNotificationSet, onClose, undefined, empty_1(), new RequestedValue$1(0, []), new RequestedValue$1(0, []), undefined, undefined, userData, reservationId, true), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(string_type)));
    })))), "/api/tools/reservations/name-suggestions", (Item) => (new Msg(11, [Item])), (Item_1) => (new Msg(19, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_3), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_1) => {
        const pr_1 = response_1.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Storage_$reflection())));
    })))), "/api/storages", (Item_2) => (new Msg(13, [Item_2])), (Item_3) => (new Msg(19, [Item_3]))), Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_6), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
        const pr_2 = response_2.arrayBuffer();
        return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(Receiver_$reflection())));
    })))), "/api/receivers", (Item_4) => (new Msg(12, [Item_4])), (Item_5) => (new Msg(19, [Item_5]))), getConsumableDetailDto((Item_6) => (new Msg(14, [Item_6])), (Item_7) => (new Msg(19, [Item_7])), consumableId)]))];
}

export function EditConsumableReservationDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.ConsumableId, props.SuccessCallback, undefined, false, props.OnClose, props.UserData, props.ReservationId), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("dialog.reservation.edit_title"), {
        Body: toList(delay(() => {
            const matchValue = state_1.Storages;
            const matchValue_1 = state_1.Receivers;
            const matchValue_2 = state_1.Consumable;
            let matchResult, consumable, receivers, storages;
            if (matchValue.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_2.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                consumable = matchValue_2.fields[0];
                receivers = matchValue_1.fields[0];
                storages = matchValue.fields[0];
            }
            switch (matchResult) {
                case 0:
                    return singleton_1(createElement(DialogBody, {
                        Consumable: consumable,
                        Description: state_1.Description,
                        EndDate: state_1.EndDate,
                        FormState: state_1.FormState,
                        IsEnoughStock: state_1.IsEnoughStock,
                        IsReceiverNotificationSet: state_1.IsUserNotificationSet,
                        Quantity: unwrap(state_1.Quantity),
                        ReminderDates: consumable.Reminders,
                        ReservationName: state_1.Name,
                        ReservervationNameSuggestions: state_1.ReservationNameSuggestions,
                        SelectedReceiver: unwrap(state_1.SelectedUser),
                        SelectedStorage: unwrap(state_1.SelectedStorage),
                        SetDescription: (value_3) => {
                            dispatch(new Msg(4, [value_3]));
                        },
                        SetEndDate: (value_6) => {
                            dispatch(new Msg(6, [value_6]));
                        },
                        SetIsReceiverNotificationSet: (value_4) => {
                            dispatch(new Msg(3, [value_4]));
                        },
                        SetQuantity: (arg) => {
                            dispatch(new Msg(7, [arg]));
                        },
                        SetReservationName: (value_2) => {
                            dispatch(new Msg(2, [value_2]));
                        },
                        SetSelectedReceiver: (value) => {
                            dispatch(new Msg(0, [value]));
                        },
                        SetSelectedStorage: (value_1) => {
                            dispatch(new Msg(1, [value_1]));
                        },
                        SetStartDate: (value_5) => {
                            dispatch(new Msg(5, [value_5]));
                        },
                        StartDate: state_1.StartDate,
                        Storages: storages,
                        SuccessCallback: props.SuccessCallback,
                        UserData: props.UserData,
                        Users: receivers,
                    }));
                default:
                    return singleton_1(createElement(Skeleton, {
                        Variant: "normal",
                    }));
            }
        })),
        Controls: toList(delay(() => {
            const matchValue_4 = state_1.Storages;
            const matchValue_5 = state_1.Receivers;
            const matchValue_6 = state_1.Consumable;
            let matchResult_1, consumable_1, receivers_1, storages_1;
            if (matchValue_4.tag === 1) {
                if (matchValue_5.tag === 1) {
                    if (matchValue_6.tag === 1) {
                        matchResult_1 = 0;
                        consumable_1 = matchValue_6.fields[0];
                        receivers_1 = matchValue_5.fields[0];
                        storages_1 = matchValue_4.fields[0];
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return append(singleton_1(createElement(TextButton, {
                        ComponentState: componentState,
                        Label: t("general.cancel"),
                        OnClick: props.OnClose,
                        TestId: "close-reservation-dialog-test-id",
                        Variant: "blueButton",
                    })), delay(() => {
                        let Label_1;
                        return singleton_1(createElement(TextButton, (Label_1 = t("general.save"), {
                            ComponentState: (state_1.SelectedUser != null) ? ((state_1.SelectedStorage != null) ? ((state_1.Quantity != null) ? componentState : "disabled") : "disabled") : "disabled",
                            Label: Label_1,
                            OnClick: () => {
                                let ConsumableId, Id, ReceiverId, Quantity_1;
                                dispatch(new Msg(9, [(ConsumableId = ConsumableId__get_unwrap(props.ConsumableId), (Id = value_10(state_1.ConsumableReservation).Id, (ReceiverId = value_10(state_1.SelectedUser).value.Id, (Quantity_1 = defaultArg(state_1.Quantity, 0), new ConsumableReservationFormDto(Id, state_1.StartDate, state_1.EndDate, state_1.Name, ReceiverId, "", "", "", ConsumableId, state_1.IsUserNotificationSet, state_1.Description, defaultArg(map((arg_1) => unwrapStorageId(arg_1.value.Id), state_1.SelectedStorage), ""), Quantity_1)))))]));
                            },
                            TestId: "save-reservation-dialog-test-id",
                            Variant: "blueButton",
                        })));
                    }));
                default: {
                    return empty();
                }
            }
        })),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

